import Model from '../../ModelBinding/Model';
import RateCriterionCollection from './RateCriterionCollection';
import RateSuggestionCollection from '../RateSuggestion/RateSuggestionCollection';

export default class RateCriterion extends Model {
  public criterion?: string;
  public coefficient?: number;
  public suggestions?: RateSuggestionCollection;

  bind() {
    this.criterion = this.getStringAttribute('criterion');
    this.coefficient = this.getIntAttribute('coefficient');
    this.suggestions = this.getRelationCollection('suggestions', RateSuggestionCollection) as RateSuggestionCollection;
  }

  static getCollection() {
    return RateCriterionCollection;
  }
}
